import apiClient from "./api";

export const getCelebIncomingRequests = async () => {
  try {
    const response = await apiClient.get("/shoutouts/celeb-incoming-requests");
    return response.data;
  } catch (error) {
    console.error("Error fetching incoming requests:", error);
    throw (
      error.response?.data || { message: "Failed to fetch incoming requests" }
    );
  }
};

export const updateShoutoutStatus = async (requestId, status) => {
  try {
    const response = await apiClient.patch(
      `/shoutouts/update-status/${requestId}`,
      {
        status,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating shoutout status:", error);
    throw (
      error.response?.data || { message: "Failed to update shoutout status" }
    );
  }
};

export const markShoutoutAsDone = async (shoutoutId, shoutoutUrl) => {
  try {
    const response = await apiClient.patch(
      `/shoutouts/mark-done/${shoutoutId}`,
      { shoutoutUrl }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking shoutout as done:", error);
    throw (
      error.response?.data || { message: "Failed to mark shoutout as done" }
    );
  }
};

export const getCelebStatistics = async () => {
  try {
    const response = await apiClient.get("/celebs/statistics");
    return response.data;
  } catch (error) {
    console.error("Error fetching celebrity statistics:", error);
    throw error.response?.data || { message: "Failed to fetch statistics" };
  }
};
